//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debounce from "lodash/debounce";
import { mapState, mapActions } from "vuex";
import {
  getbankNameList,
  checkBankInfo,
  addBankCard,
} from "@/common/api/Amount";
import { sendPhoneCode, sendPhoneSMS } from "@/common/api/bindAuthenticate";
import { uploadFile } from "@/common/api/normal";

import MyBasePage from "../../../components/MyBasePage";

import FormField from "./components/FormField";
import IconAlipay from "./components/IconAlipay";
import IconBankcard from "./components/IconBankcard";
import IconUSDT from "./components/IconUSDT";
import IconCardOwner from "./components/IconCardOwner";
import IconPhone from "./components/IconPhone";

import ImagePicker from "./components/ImagePicker";

export default {
  props: {
    type: {
      type: String,
      default: "bankcard",
    },
  },
  components: {
    MyBasePage,
    FormField,
    IconAlipay,
    IconBankcard,
    IconUSDT,
    IconCardOwner,
    IconPhone,
    ImagePicker,
  },
  data() {
    return {
      types: [
        { name: "银行卡", value: "bankcard" },
        { name: "支付宝", value: "alipay" },
        { name: "USDT", value: "usdt" },
      ],
      // bankList: {
      //   loading: false,
      //   initialed: false,
      //   data: [],
      // },
      bankcard: {
        bankCode: null,
        bankName: "",
        cardNumber: "",
        subBank: "",
      },
      alipay: {
        bankCode: "ALIPAY",
        bankName: "支付宝",
        cardNumber: "",
        subBank: "",
        usdtPhoneCode: "",
      },
      usdtProtocols: [
        {
          name: "USDT/TRC20",
          value: "TRC20",
        },
        {
          name: "USDT/ERC20",
          value: "ERC20",
        },
      ],
      usdt: {
        bankCode: "USDT",
        bankName: "USDT",
        usdtType: "TRC20",
        subBank: "",
        cardNumber: "",
        usdtPhoneCode: "",
      },
      submitting: false,
      qrFile: null,
      verify: {
        sending: false,
        cd: 0,
        code: "",
        timer: null,
      },
    };
  },
  async created() {
    // 判断是否实名认证
    if (!this.userInfo.nameValid) {
      this.$vux.toast.show({
        text: "请先完成实名认证",
        type: "cancel",
      });
      this.$router.replace({ path: "/My/AccountManat/VerifiedAuth" });
      return;
    }

    // 判断是否绑定手机
    if (!this.userInfo.mobileValid) {
      this.$vux.toast.show({
        text: "请先绑定手机",
        type: "cancel",
      });
      this.$router.replace({ path: "/My/AccountManat/mobileAuth" });
      return;
    }

    // 判断取款密码是否已设定
    if (
      this.linkList.isWithdrawPassword === "1" &&
      !this.userInfo.withdrawPasswordValid
    ) {
      this.$vux.toast.show({
        text: "请先设定取款密码",
        type: "cancel",
      });
      this.$router.replace({ path: "/My/AccountManat/WithdrawPasword" });
      return;
    }

    // this.bankcard.personName = this.alipay.personName = this.userInfo.name
    // this.loadBanks()
  },
  computed: {
    ...mapState({
      // UUID
      UUID: (state) => state.UUID,
      // 用户信息
      userInfo: (state) => state.userInfo.userInfo,
      // 配置信息
      linkList: (state) => state.linkList,
    }),
    /** 钱包类型, 处理意外情况 */
    walletType() {
      return ["bankcard", "alipay", "usdt"].includes(this.type)
        ? this.type
        : "bankcard";
    },
  },
  watch: {
    /** 加载银行列表 */
    // type () {
    //   this.loadBanks()
    // },
    /** 更新银行名称 */
    // 'bankcard.bankCode' (n) {
    //   if (n) {
    //     this.bankcard.bankName = (
    //       this.bankList.data
    //         .find(item => item.value === n)
    //         .name
    //     )
    //   }
    // },
    "bankcard.cardNumber"() {
      this.checkCardNumber();
    },
  },
  methods: {
    ...mapActions(["getFirstInfo"]),
    /** 查询银行列表 */
    // async loadBanks () {
    //   if (
    //     this.walletType !== 'bankcard'
    //     ||
    //     this.bankList.initialed
    //     ||
    //     this.bankList.loading
    //   ) {
    //     return
    //   }

    //   try {
    //     this.bankList.loading = true
    //     const [bankList] = await getbankNameList({ UUID: this.UUID })
    //     if (bankList && bankList.length) {
    //       this.bankList = {
    //         loading: false,
    //         initialed: true,
    //         data: bankList.map(
    //           item => ({
    //             name: item.bank_name,
    //             value: item.bank_code,
    //           })
    //         ),
    //       }
    //       this.bankcard.bankCode = bankList[0].bank_code
    //     }
    //   } finally {
    //     // this.bankList.loading = false
    //   }
    // },
    checkCardNumber: debounce(async function () {
      if (this.bankcard.cardNumber.length >= 13) {
        const [bankinfo] = await checkBankInfo({
          UUID: this.UUID,
          cardNumber: this.bankcard.cardNumber,
        });

        if (bankinfo) {
          this.bankcard.bankCode = bankinfo.bankCode;
          this.bankcard.bankName = bankinfo.bankName;
          return;
        }
      }

      this.bankcard.bankCode = null;
      this.bankcard.bankName = "";
    }, 400),
    /** 类型切换 */
    handleTypeChange([value]) {
      if (value !== this.type) {
        this.$router.replace(`/My/Wallet/AddWallet/${value}`);
      }
    },
    /** 校验银行卡 */
    async bankcardValidate() {
      // 校验卡号
      if (!/^([1-9]{1})(\d{15}|\d{18})$/.test(this.bankcard.cardNumber)) {
        return {
          validate: false,
          msg: "银行卡号不正确",
        };
      }
      // 卡户支行
      if (!/^.{1,100}$/.test(this.bankcard.subBank)) {
        return {
          validate: false,
          msg: "开户支行不正确",
        };
      }
      return { validate: true };
    },
    /** 校验支付宝 */
    async alipayValidate() {
      // 校验支付宝账号
      if (
        !/^([1-9]\d{1,3}-\d{4,14}|1[3-9]\d{9}|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/.test(
          this.alipay.cardNumber
        )
      ) {
        return {
          validate: false,
          msg: "账号不正确",
        };
      }

      // 校验验证码
      if (!/[1-9a-zA-Z]{4,6}/.test(this.verify.code)) {
        return {
          validate: false,
          msg: "验证码不正确",
        };
      }
      this.alipay.usdtPhoneCode = this.verify.code;

      // 校验收款图并上传以及回填对应字段
      // if (!this.qrFile) {
      //   return {
      //     validate: false,
      //     msg: "收款码不能为空",
      //   };
      // }
      if (this.qrFile && this.qrFile.size > 1024 * 1024 * 5) {
        return {
          validate: false,
          msg: "图片大于5M",
        };
      }

      const formData = new FormData();
      formData.append("file", this.qrFile);
      formData.append("UUID", this.UUID);

      try {
        if (this.qrFile) {
          const result = await uploadFile(formData);
          if (result.data.code == 200 && Boolean(result.data.data)) {
            this.alipay.subBank = result.data.data;
            return { validate: true };
          } else {
            return {
              validate: false,
              msg: "图上传失败",
            };
          }
        } else {
          return { validate: true };
        }
      } catch (e) {}
    },
    /** 校验虚拟货币 */
    async usdtValidate() {
      // 校验别名
      if (!/^.{6,50}$/.test(this.usdt.subBank)) {
        return {
          validate: false,
          msg: "别名不正确",
        };
      }
      // 校验地址
      if (!/^\w{11,40}$/.test(this.usdt.cardNumber)) {
        return {
          validate: false,
          msg: "地址不正确",
        };
      }
      // 校验验证码
      if (!/[1-9a-zA-Z]{4,6}/.test(this.verify.code)) {
        return {
          validate: false,
          msg: "验证码不正确",
        };
      }
      this.usdt.usdtPhoneCode = this.verify.code;

      return { validate: true };
    },
    /** 发送验证码 */
    async handleSend() {
      if (this.verify.sending || this.verify.cd > 0) {
        return;
      }

      try {
        const [data, error] = await sendPhoneSMS({
          UUID: this.UUID,
          areaCode: this.userInfo.mobileArea || "86",
          phone: this.userInfo.mobilePhone,
        });
        if (error) {
          this.$vux.toast.show({
            text: error.message,
            type: "cancel",
          });
          return;
        }

        this.verify.cd = 150;
        this.verify.timer = setInterval(() => {
          if (this.verify.cd <= 0) {
            clearInterval(this.timer);
            return;
          }

          this.verify.cd = this.verify.cd - 1;
        }, 1000);
      } finally {
        this.verify.sending = false;
      }
    },
    /** 提交 */
    async handleSubmit() {
      if (this.submitting) {
        return;
      }

      try {
        this.submitting = true;

        // 根据类型调用对应的校验
        // bankcardValidate, aplipayValidate, usdtValidate
        const validation = await this[`${this.type}Validate`]();
        if (!validation.validate) {
          this.$vux.toast.show({
            text: validation.msg,
            type: "cancel",
          });
          return;
        }

        // 将要提交的数据
        const form = {
          // 页面输入内容
          ...this[this.type],
          UUID: this.UUID,
          withdrawPassword: "",
          personName: this.userInfo.name,
          bankBindPhone: this.userInfo.mobilePhone,
        };

        // 提交
        const [data, error] = await addBankCard(form);

        if (error) {
          this.$vux.toast.show({
            text: error.message,
            type: "cancel",
          });
          return;
        }

        this.getFirstInfo();
        this.$vux.toast.show({
          text: "银行卡绑定成功",
          type: "success",
        });

        if (window.history.length < 2) {
          this.$router.replace("/My");
          return;
        }
        this.$router.go(-1);
      } finally {
        this.submitting = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Wallet/AddWallet/index.vue